'use client'

import type { UseManyProductsProps } from '@maestro/commerce-blocks/hooks/hooks.types'

import { useMemo } from 'react'

import { useProductPriceDataFetcher } from '@maestro/commerce-blocks/hooks/use-product-price-data-fetcher'
import {
  buildManyProductsContext,
  reportFalsyIds,
} from '@maestro/commerce-blocks/utils/report-falsy-ids'

export const useManyProductsPrice = (props: UseManyProductsProps) => {
  const { serverProducts, fetchPriceClientSide = false, listingType } = props
  const productIds = useMemo(() => {
    if (!serverProducts.length || !fetchPriceClientSide) {
      return []
    }
    const rawIds = serverProducts.map((product) => product.id)
    reportFalsyIds({
      hookName: 'useManyProductsPrice',
      listingType,
      rawIds,
      productContext: buildManyProductsContext(serverProducts),
    })
    return rawIds.filter(Boolean)
  }, [fetchPriceClientSide, listingType, serverProducts])

  const { productsPriceMap, isLoading } = useProductPriceDataFetcher({
    productIds,
  })

  const productsWithPrice = useMemo(() => {
    if (!serverProducts.length || !productsPriceMap) {
      return serverProducts
    }
    return serverProducts.map((product) => ({
      ...product,
      price: productsPriceMap[product.id] ?? product.price,
    }))
  }, [serverProducts, productsPriceMap])

  return {
    products: productsWithPrice,
    isLoading,
  }
}
